import styled, {css} from 'styled-components'

// Row of operational cards shown under the page header. Cards keep a comfortable width and wrap
// on narrow viewports rather than stretching across the whole page.
export const StyledCardsRow = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        flex-wrap: wrap;
        gap: ${spacing * 2}px;
    `
)

// Card chrome — mirrors the accesses/absences dashboard cards. The `$disabled` variant (dashed
// border, muted background) marks a not-yet-available card (e.g. the merge placeholder).
export const StyledExportCard = styled.div<{$disabled?: boolean}>(
    ({theme: {palette, spacing}, $disabled}) => css`
        flex: 1 1 0;
        min-width: 280px;
        display: flex;
        flex-direction: column;
        gap: ${spacing * 4}px;
        padding: ${spacing * 3}px;
        background-color: ${palette.neutral.white};
        border: 1px solid ${palette.neutral[200]};
        border-radius: 8px;

        ${$disabled &&
        css`
            border-style: dashed;
            background-color: ${palette.neutral[50]};
        `}
    `
)

export const StyledCardHeader = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: ${spacing * 2}px;
    `
)

// Rounded-square badge holding the card's icon (or the ".TXT" label for the DSP Flux card).
export const StyledIconChip = styled.div<{$tone: 'success' | 'neutral'}>(
    ({theme: {palette, spacing}, $tone}) => css`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: ${spacing * 10}px;
        height: ${spacing * 10}px;
        border-radius: 8px;
        background-color: ${$tone === 'success' ? palette.success[50] : palette.neutral[100]};
        color: ${$tone === 'success' ? palette.success[600] : palette.neutral[500]};
    `
)

// The ".TXT" wordmark inside the DSP Flux icon chip — recalls the extension of the downloaded file.
export const StyledTxtBadge = styled.span(
    ({theme: {typography}}) => css`
        ${typography.textXs};
        font-weight: 700;
        letter-spacing: 0.02em;
    `
)

// Bottom row: the month select (grows) beside the action button.
export const StyledCardFooter = styled.div(
    ({theme: {spacing}}) => css`
        display: flex;
        align-items: center;
        gap: ${spacing * 2}px;
    `
)

export const StyledSelectWrapper = styled.div`
    flex: 1;
    min-width: 0;
`

// Wraps a disabled action button so its explanatory tooltip still opens on hover.
export const StyledDisabledActionWrapper = styled.span`
    display: inline-flex;

    & > button {
        pointer-events: none;
    }
`
